/* ------------------------------------------------------------------------------
@name: SelectData
@description: SelectData
--------------------------------------------------------------------------------- */

const SelectData = (() => {
  // handleClickSelect
  const handleClickSelect = () => {
    // select single data
    $("body").on("click", ".js-select-data", () => {
      var _checkLength = $(".js-select-data").length;
      var _checkedLength = $(".js-select-data:checked").length;

      if (_checkLength === _checkedLength) {
        $(".js-select-all").prop("checked", true);
      } else {
        $(".js-select-all").prop("checked", false);
      }
      handleToggleDelete();
    });

    // select all data
    $(".js-select-all").on("click", (e) => {
      const _this = $(e.currentTarget);
      var _isChecked = _this.is(":checked");
      var _parent = _this.parents("table");

      if (_isChecked) {
        _parent.find(".js-select-data").prop("checked", true);
      } else {
        _parent.find(".js-select-data").prop("checked", false);
      }
      handleToggleDelete();
    });
  };

  // handleSelectGroup
  const handleSelectGroup = () => {
    // select single data
    $("body").on("click", ".js-select-data", (e) => {
      const _this = $(e.currentTarget);
      var _checkLength = _this
        .parents(".setting-row")
        .find(".js-select-data").length;
      var _checkedLength = _this
        .parents(".setting-row")
        .find(".js-select-data:checked").length;
      var _parent = _this.parents(".setting-row");

      if (_checkLength === _checkedLength) {
        _parent.find(".js-select-group").prop("checked", true);
      } else {
        _parent.find(".js-select-group").prop("checked", false);
      }
      handleToggleDelete();
    });

    // select group data
    $("body").on("click", ".js-select-group", (e) => {
      const _this = $(e.currentTarget);
      var _isChecked = _this.is(":checked");
      var _parent = _this.parents(".setting-row");

      if (_isChecked) {
        _parent.find(".js-select-data").prop("checked", true);
      } else {
        _parent.find(".js-select-data").prop("checked", false);
      }
      handleToggleDelete();
    });
  };

  // handleToggleDelete
  const handleToggleDelete = () => {
    var _checkLength = $(".js-select-data:checked").length;

    if (_checkLength > 0) {
      $("body").find(".js-print-all-data").removeClass("d-none");
      $("body").find(".js-edit-all-data").removeClass("d-none");
    } else {
      $("body").find(".js-print-all-data").addClass("d-none");
      $("body").find(".js-edit-all-data").addClass("d-none");
    }
  };

  const init = () => {
    if ($(".js-select-all").length) {
      handleClickSelect();
    }
    handleSelectGroup();
  };

  return {
    init,
  };
})();

export default SelectData;
